
import { api } from "@/utils/request";

export default {
  data() {
    return {
      isCarouselReady: false,
      breadcrumb: [
        {
          text: "Home",
          to: "/",
        },
        {
          text: "Article",
          active: true,
        },
      ],
      search: "",
      featuredBlogData: [],
      loadingFeaturedBlog: true,
      articleData: [],
      otherArticleList: [],
      isArticleListReady: false,
      isPopularListReady: false,
      otherPopularList: [],
      popularList: [],
      pagination: {
        currentPage: 1,
        perPage: 6,
      },
      title: 'Popular Article',
      isEmptyPage: false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.isArticleListReady = true;
    }, 2000);
  },
  methods: {
    changePaging(page) {
      this.pagination = {
        ...this.pagination,
        currentPage: page,
      }
      this.fetchArticleList()
    },
    onInitCarousel () {
      this.isCarouselReady = true;
    },
    searchArticle(val) {
      this.search = val
      this.fetchArticleList(val);
    },
    async fetchFeaturedBlogList() {
      try {
        const blogs = await api('featured-blogs')
        if (blogs && blogs.result) {
          this.featuredBlogData = blogs.result;
          this.loadingFeaturedBlog = false
        }
      } catch (e) {
        console.error(e)
      }
    },
    searchByCategory(val) {
      this.search = ''
      this.fetchArticleList('', val)
    },
    async fetchArticleList(search= '', category= '') {
      this.articleData= [];
      this.isEmptyPage = false;
      try {
        const reqParams = {
          page: this.pagination.currentPage || 1,
          perPage: this.pagination.perPage,
        }

        if (search) reqParams.search = search;
        if (category) reqParams.category = category;

        const articles = await api('blogs', reqParams)

        if (articles) {
          const result = articles.result;

          const pagination = this.pagination;
          pagination.currentPage = result.currentPage;
          pagination.totalPages = result.totalPages;
          pagination.rows = result.totalPages * this.pagination.perPage;

          this.pagination = pagination;
          this.articleData = result.blogs;
          this.isEmptyPage = !result.blogs.length;
        }
      } catch (e) {
        this.pagination = {
          ...this.pagination,
          currentPage: 1,
          totalPages: 1,
        };
        this.articleData = [];
        this.isEmptyPage = true;
      }
    },
    getFilterData() {
      setTimeout(() => {
        this.popularList=[
          {
            mediaTitle: "Trending",
            isActive: true,
          },
          {
            mediaTitle: "Lorem Ipsum Dolor Sit Amet",
            isActive: false,
          },
          {
            mediaTitle: "Lorem Ipsum Dolor Sit Amet",
            isActive: false,
          },
          {
            mediaTitle: "Lorem Ipsum Dolor Sit Amet",
            isActive: false,
          },
        ],
        this.otherPopularList = [
          {
            mediaTitle: "Archive",
            isActive: false,
          },
        ];
        this.isPopularListReady = true;
      }, 3000);
    },
  },
  async created() {
    this.getFilterData()
    this.fetchFeaturedBlogList();
    this.fetchArticleList();
  },
};
